import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { BusinessEntityModel } from '../model';
import { Subject } from 'rxjs';
import { IFormStore } from '../interface';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: BusinessEntityModel };

const initialState: State = { state: 'idle' };

@Injectable()
export class BusinessEntityStore extends ComponentStore<State> implements IFormStore {
  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));
  readonly setDataValid = this.updater<BusinessEntityModel>((_, data) => {
    return { state: 'valid', data: BusinessEntityModel.fromJson(data) };
  });
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));
  readonly submit$ = new Subject<void>();

  constructor() {
    super(initialState);
  }
}
